// extracted by mini-css-extract-plugin
export default {"billingAddress":"src-pages-Order-Components-BillingAddress-css-module__billingAddress--j7efy"};